import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, MenuItem, Select, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { useNavigate } from "react-router-dom";
import { CuisineDishService } from "../../services/CuisineDishService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import { DishTierEnum } from "../../enums/DishTierEnum";
import { BookByDishPlateUnit } from "../../enums/BookByDishPlateUnit";
import { FoodCategory } from "../../enums/FoodCatergory";
import {
    FilledButton,
    FormFieldGroup,
    FormGrid,
    FormLabel,
    OutlinedDelButton,
    ThreeColGrid,
} from "../../styles/commonStyles";
import { colors } from "../../styles/colors";

const fieldStyle = (theme: any) => ({
    borderRadius: "8px",
    backgroundColor: theme.palette.mode === "dark" ? "rgb(19, 24, 32)" : "rgb(249, 250, 251)",
    border: theme.palette.mode === "dark"
        ? "1px solid rgba(138, 153, 168, 0.2)"
        : "1px solid rgba(108, 124, 147, 0.2)",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    fontSize: "14px",
    color: theme.palette.mode === "dark" ? "rgb(249, 250, 251)" : "rgb(29, 37, 48)",
});

const DishTextField = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-root": {
        ...fieldStyle(theme),
        "& fieldset": { border: "none" },
        "&:hover": {
            border: theme.palette.mode === "dark"
                ? "1px solid rgba(138, 153, 168, 0.35)"
                : "1px solid rgba(108, 124, 147, 0.35)",
        },
        "&.Mui-focused": {
            border: "1px solid rgba(25, 117, 210, 0.8)",
            boxShadow: "0 0 0 3px rgba(25, 117, 210, 0.1)",
        },
    },
    "& .MuiInputBase-input": {
        padding: "10px 14px",
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "rgb(249, 250, 251)" : "rgb(29, 37, 48)",
        "&::placeholder": { color: "rgb(108, 124, 147)", opacity: 1 },
    },
    "& .MuiFormHelperText-root": { margin: "4px 0 0 0", fontSize: "12px" },
}));

const DishSelect = styled(Select)(({ theme }) => ({
    ...fieldStyle(theme),
    "& .MuiSelect-select": {
        padding: "10px 14px",
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "rgb(249, 250, 251)" : "rgb(29, 37, 48)",
        paddingRight: "36px !important",
        whiteSpace: "normal",
        height: "auto !important",
    },
    "& fieldset": { border: "none" },
    "&::before": { display: "none" },
    "&::after": { display: "none" },
    "&:hover": {
        border: theme.palette.mode === "dark"
            ? "1px solid rgba(138, 153, 168, 0.35)"
            : "1px solid rgba(108, 124, 147, 0.35)",
    },
    "&.Mui-focused": {
        border: "1px solid rgba(25, 117, 210, 0.8)",
        boxShadow: "0 0 0 3px rgba(25, 117, 210, 0.1)",
    },
    "& .MuiSelect-icon": {
        color: "rgb(108, 124, 147)",
        right: "10px",
    },
}));


const getEquipmentIds = (requiredEquipments: any[] = []) => {
    return requiredEquipments
        .map((equipment: any) => {
            if (typeof equipment === "number") {
                return equipment;
            }
            return equipment?.equipmentId || equipment?.dishEquipmentId || equipment?.EquipmentModelV2?.id || equipment?.equipment?.id || equipment?.id;
        })
        .filter((id: number) => Boolean(id));
};

const getTagIds = (categoryTags: any[] = []) => {
    return categoryTags
        .map((tag: any) => {
            if (typeof tag === "number") {
                return tag;
            }
            return tag?.tagId || tag?.id;
        })
        .filter((id: number) => Boolean(id));
};

const getInstructionCategoryIds = (instructions: any[] = []) => {
    return instructions
        .map((instruction: any) => {
            if (typeof instruction === "number") {
                return instruction;
            }
            return instruction?.categoryId || instruction?.category?.id || instruction?.id;
        })
        .filter((id: number) => Boolean(id));
};

const getInstructionInputs = (instructions: any[] = []) => {
    return instructions.reduce((acc: Record<number, string>, instruction: any) => {
        if (typeof instruction === "number") {
            return acc;
        }
        const categoryId = instruction?.categoryId || instruction?.category?.id || instruction?.id;
        if (categoryId) {
            acc[categoryId] = instruction?.instruction || "";
        }
        return acc;
    }, {});
};


let cuisineDishService = new CuisineDishService();
function UpdateDishDataDialog(props: any) {
    const navigate = useNavigate();
    let[name, setName] = React.useState<string>(props?.data?.name || "");
    let[nameHi, setNameHi] = React.useState<string>(props?.data?.nameHi || "");
    let[nameBn, setNameBn] = React.useState<string>(props?.data?.nameBn || "");
    let[categoryId, setCategoryId] = React.useState<number>(props?.data?.categoryId || 0);
    let[mealType, setMealType] = React.useState<string>(props?.data?.mealType || "");
    let[type, setType] = React.useState<string>(props?.data?.type || "");
    let[description, setDescription] = React.useState<string>(props?.data?.description || "");
    let[forChefit, setForChefit] = React.useState<boolean>(props?.data?.forChefit || false);
    let[forParty, setForParty] = React.useState<boolean>(props?.data?.forParty || false);
    let[dishType, setDishType] = React.useState<string>(props?.data?.dishType || "");
    let[forBookByDish, setForBookByDish] = React.useState<boolean>(props?.data?.forBookByDish || false);
    let[isPopular, setIsPopular] = React.useState<boolean>(props?.data?.isPopular || false);
    let[dishTier, setDishTier] = React.useState<string>(props?.data?.dishTier || "");
    let[filterCategory, setFilterCategory] = React.useState<string>(props?.data?.filterCategory || "");
    let[basePrice, setBasePrice] = React.useState<string>(props?.data?.basePrice ?? "");
    let[baseTime, setBaseTime] = React.useState<string>(props?.data?.baseTime ?? "");
    let[basePeople, setBasePeople] = React.useState<string>(props?.data?.basePeople ?? "");
    // Bread plate configuration (Book by Dish). basePrice/baseTime stay the legacy per-piece rates.
    let[plateSize, setPlateSize] = React.useState<string>(props?.data?.plateSize ?? "");
    let[plateUnit, setPlateUnit] = React.useState<string>(props?.data?.plateUnit ?? "");
    let[pricePerPlate, setPricePerPlate] = React.useState<string>(props?.data?.pricePerPlate ?? "");
    let[timePerPlate, setTimePerPlate] = React.useState<string>(props?.data?.timePerPlate ?? "");
    let[categories, setCategories] = React.useState<any>([]);
    let[dishEquipments, setDishEquipments] = React.useState<any>([]);
    let[dishInstructionCategories, setDishInstructionCategories] = React.useState<any>([]);
    let[requiredEquipments, setRequiredEquipments] = React.useState<number[]>(getEquipmentIds(props?.data?.requiredEquipments || props?.data?.equipments));
    let[selectedInstructionCategories, setSelectedInstructionCategories] = React.useState<number[]>(getInstructionCategoryIds(props?.data?.instructions));
    let[instructionInputs, setInstructionInputs] = React.useState<Record<number, string>>(getInstructionInputs(props?.data?.instructions));
    let[showInstructionValidation, setShowInstructionValidation] = React.useState<boolean>(false);
    let[categoryTags, setCategoryTags] = React.useState<any>([]);
    let[selectedTagIds, setSelectedTagIds] = React.useState<number[]>(getTagIds(props?.data?.categoryTags));


    React.useEffect(() => {
        getDialogData();
    }, []);


    let getDialogData = async() => {
        try {
            const [categoryData, equipmentData, instructionCategoryData, categoryTagData] = await Promise.all([
                cuisineDishService.getDishCategories(),
                cuisineDishService.getDishEquipments(),
                cuisineDishService.getDishInstructionCategories(),
                cuisineDishService.getCategoryTags(),
            ]);

            if (categoryData) {
                setCategories(categoryData);
            }
            if (equipmentData) {
                setDishEquipments(equipmentData);
            }
            if (instructionCategoryData) {
                setDishInstructionCategories(instructionCategoryData);
            }
            if (categoryTagData) {
                setCategoryTags(categoryTagData);
            }
        } catch (error) {
            console.error("Failed to fetch dish metadata", error);
        }
    }

    let getInstructionCategoryName = (categoryId: number) => {
        return dishInstructionCategories.find((category: any) => category?.id === categoryId)?.name || `Instruction ${categoryId}`;
    }

    let getSelectedNames = (selectedIds: number[], options: any[]) => {
        return selectedIds
            .map((id: number) => options.find((option: any) => option?.id === id)?.name)
            .filter((name: string) => Boolean(name))
            .join(", ");
    }

    let getNormalizedIds = (value: any) => {
        if (Array.isArray(value)) {
            return value.map((id: any) => Number(id));
        }
        if (!value) {
            return [];
        }
        return value.split(",").map((id: string) => Number(id));
    }

    let isInstructionTextMissing = (categoryId: number) => {
        return !instructionInputs[categoryId]?.trim();
    }

    let handleSubmit = async () => {
        if (!name || !categoryId || !mealType) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Please fill all the required fields",
                type: CustomSnackbarTypes.ERROR,
            });
            return;
        }

        const instructions = selectedInstructionCategories.map((categoryId: number) => ({
            categoryId,
            instruction: instructionInputs[categoryId]?.trim() || "",
        }));

        if (instructions.some((instruction: any) => !instruction.instruction)) {
            setShowInstructionValidation(true);
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Please add dish instruction text for all selected instruction categories",
                type: CustomSnackbarTypes.ERROR,
            });
            return;
        }

        setShowInstructionValidation(false);

        // The backend hides a bread dish from the Book by Dish catalogue unless all four plate
        // fields are set, so a partial configuration is never what ops wants.
        const isBread = dishType === FoodCategory.BREAD;
        const plateFields = [plateSize, plateUnit, pricePerPlate, timePerPlate];
        const filledPlateFields = plateFields.filter((v) => v !== "" && v != null).length;
        if (isBread && filledPlateFields > 0 && filledPlateFields < plateFields.length) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Fill all plate fields (size, unit, price, time) or leave them all empty",
                type: CustomSnackbarTypes.ERROR,
            });
            return;
        }
        if (isBread && filledPlateFields > 0 && !(Number(plateSize) >= 1)) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Plate size must be at least 1",
                type: CustomSnackbarTypes.ERROR,
            });
            return;
        }

        let payload:any = {
            name,
            categoryId,
            mealType,
            forChefit,
            forParty,
            requiredEquipments,
            instructions,
            categoryTagIds: selectedTagIds,
        };
        if (nameHi) {
            payload["nameHi"] = nameHi;
        }
        if (nameBn) {
            payload["nameBn"] = nameBn;
        }
        if (type) {
            payload["type"] = type;
        }
        if (description) {
            payload["description"] = description;
        }
        if (dishType) {
            payload["dishType"] = dishType;
        }
        payload["forBookByDish"] = forBookByDish;
        payload["isPopular"] = isPopular;
        if (dishTier) {
            payload["dishTier"] = dishTier;
        }
        payload["filterCategory"] = filterCategory;
        if (basePrice !== "" && basePrice != null) {
            payload["basePrice"] = Number(basePrice);
        }
        if (baseTime !== "" && baseTime != null) {
            payload["baseTime"] = Number(baseTime);
        }
        if (basePeople !== "" && basePeople != null) {
            payload["basePeople"] = Number(basePeople);
        }
        if (isBread && filledPlateFields > 0) {
            payload["plateSize"] = Number(plateSize);
            payload["plateUnit"] = plateUnit;
            payload["pricePerPlate"] = Number(pricePerPlate);
            payload["timePerPlate"] = Number(timePerPlate);
        }
        try {
            await cuisineDishService.updateDish(props?.data?.id ,payload);
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Updated Successfully",
                type: CustomSnackbarTypes.SUCCESS,
            });
            props.callBack();
            setName("");
            setNameHi("");
            setNameBn("");
            setCategoryId(0);
            setMealType("");
            setType("");
            setDescription("");
            setForChefit(false);
            setForParty(false);
            setDishType("");
            setForBookByDish(false);
            setIsPopular(false);
            setDishTier("");
            setFilterCategory("");
            setBasePrice("");
            setBaseTime("");
            setBasePeople("");
            setPlateSize("");
            setPlateUnit("");
            setPricePerPlate("");
            setTimePerPlate("");
            setCategories([]);
            setDishEquipments([]);
            setDishInstructionCategories([]);
            setRequiredEquipments([]);
            setSelectedInstructionCategories([]);
            setInstructionInputs({});
            setShowInstructionValidation(false);
            setCategoryTags([]);
            setSelectedTagIds([]);
            window.location.reload();
            navigate(`/CuisineDish/${props?.data?.id}/show`);

        } catch (error) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Failed to update Cuisine Dish",
                type: CustomSnackbarTypes.ERROR,
            });
        }
    }
  return (
    <div>
        <Dialog open={props.open} scroll="paper" maxWidth="md" fullWidth>
          <DialogTitle>Update Dish</DialogTitle>
          <DialogContent dividers>

            {/* Row 1 — Names */}
            <ThreeColGrid style={{ marginTop: 0 }}>
              <FormFieldGroup>
                <FormLabel>Name</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Name"
                  value={name}
                  onChange={(e: any) => setName(e.target.value)}
                />
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Name in Hindi</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Name in Hindi"
                  value={nameHi}
                  onChange={(e: any) => setNameHi(e.target.value)}
                />
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Name in Bengali</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Name in Bengali"
                  value={nameBn}
                  onChange={(e: any) => setNameBn(e.target.value)}
                />
              </FormFieldGroup>
            </ThreeColGrid>

            {/* Row 2 — Category / Meal Type / Type */}
            <ThreeColGrid>
              <FormFieldGroup>
                <FormLabel>Category</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    value={categoryId}
                    onChange={(e: any) => setCategoryId(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value={0} disabled>Select Category</MenuItem>
                    {categories.map((e: any) => (
                      <MenuItem key={e?.name} value={e?.id}>{e?.name}</MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Meal Type</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    value={mealType}
                    onChange={(e: any) => setMealType(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select Meal Type</MenuItem>
                    {["STARTER", "MAIN COURSE", "DESSERT", "SIDE_DISH", "BEVERAGE"].map((e) => (
                      <MenuItem key={e} value={e}>{e}</MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Type</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    value={type}
                    onChange={(e: any) => setType(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select Type</MenuItem>
                    {["VEG", "NON_VEG", "ANY"].map((e) => (
                      <MenuItem key={e} value={e}>{e}</MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
            </ThreeColGrid>

            {/* Row 3 — Dish Type / Dish Tier / Filter Category */}
            <ThreeColGrid>
              <FormFieldGroup>
                <FormLabel>Dish Type</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    value={dishType}
                    onChange={(e: any) => setDishType(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select Dish Type</MenuItem>
                    {["BREAD", "CURRY"].map((e) => (
                      <MenuItem key={e} value={e}>{e}</MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Dish Tier</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    value={dishTier}
                    onChange={(e: any) => setDishTier(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select Dish Tier</MenuItem>
                    {Object.values(DishTierEnum).map((e: any) => (
                      <MenuItem key={e} value={e}>{e}</MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Filter Category</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Filter Category"
                  value={filterCategory}
                  onChange={(e: any) => setFilterCategory(e.target.value)}
                />
              </FormFieldGroup>
            </ThreeColGrid>

            {/* Row 4 — Base Price / Base Time / Base People */}
            <ThreeColGrid>
              <FormFieldGroup>
                <FormLabel>Base Price</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Base Price"
                  value={basePrice}
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  onChange={(e: any) => setBasePrice(e.target.value)}
                />
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Base Time (min)</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Base Time"
                  value={baseTime}
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  onChange={(e: any) => setBaseTime(e.target.value)}
                />
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Base People</FormLabel>
                <DishTextField
                  fullWidth
                  variant="outlined"
                  placeholder="Base People"
                  value={basePeople}
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  onChange={(e: any) => setBasePeople(e.target.value)}
                />
              </FormFieldGroup>
            </ThreeColGrid>

            {/* Bread plate configuration — Book by Dish sells bread by the plate */}
            {dishType === FoodCategory.BREAD && (
              <>
                <ThreeColGrid>
                  <FormFieldGroup>
                    <FormLabel>Plate Size (pcs)</FormLabel>
                    <DishTextField
                      fullWidth
                      variant="outlined"
                      placeholder="Pieces in one plate"
                      value={plateSize}
                      type="number"
                      InputProps={{ inputProps: { min: 1 } }}
                      onChange={(e: any) => setPlateSize(e.target.value)}
                    />
                  </FormFieldGroup>
                  <FormFieldGroup>
                    <FormLabel>Plate Unit</FormLabel>
                    <FormControl style={{ width: "100%" }}>
                      <DishSelect
                        value={plateUnit}
                        onChange={(e: any) => setPlateUnit(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>Select Plate Unit</MenuItem>
                        {Object.values(BookByDishPlateUnit).map((e) => (
                          <MenuItem key={e} value={e}>{e}</MenuItem>
                        ))}
                      </DishSelect>
                    </FormControl>
                  </FormFieldGroup>
                  <FormFieldGroup>
                    <FormLabel>Price per Plate</FormLabel>
                    <DishTextField
                      fullWidth
                      variant="outlined"
                      placeholder="Price of one plate"
                      value={pricePerPlate}
                      type="number"
                      InputProps={{ inputProps: { min: 0 } }}
                      onChange={(e: any) => setPricePerPlate(e.target.value)}
                    />
                  </FormFieldGroup>
                </ThreeColGrid>
                <ThreeColGrid>
                  <FormFieldGroup>
                    <FormLabel>Time per Plate (min)</FormLabel>
                    <DishTextField
                      fullWidth
                      variant="outlined"
                      placeholder="Cook time for one plate"
                      value={timePerPlate}
                      type="number"
                      InputProps={{ inputProps: { min: 0 } }}
                      onChange={(e: any) => setTimePerPlate(e.target.value)}
                      helperText="Base Price / Base Time stay the per-piece rates used by older app builds."
                    />
                  </FormFieldGroup>
                </ThreeColGrid>
              </>
            )}

            {/* Row 5 — Equipment / Instructions / Category Tags */}
            <ThreeColGrid>
              <FormFieldGroup>
                <FormLabel>Dish Equipment</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    multiple
                    value={requiredEquipments}
                    renderValue={(selected: any) => (
                      <div>
                        {getSelectedNames(selected as number[], dishEquipments).split(", ").map((name, i) => (
                          <div key={i} style={{ lineHeight: "1.8" }}>{name}</div>
                        ))}
                      </div>
                    )}
                    onChange={(e: any) => setRequiredEquipments(getNormalizedIds(e.target.value))}
                    displayEmpty
                  >
                    {dishEquipments.map((equipment: any) => (
                      <MenuItem key={equipment?.id} value={equipment?.id}>
                        <Checkbox checked={requiredEquipments.includes(equipment?.id)} sx={{ "& .MuiSvgIcon-root": { color: colors.primary } }} />
                        {equipment?.name}
                      </MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Dish Instruction</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    multiple
                    value={selectedInstructionCategories}
                    renderValue={(selected: any) => (
                      <div>
                        {getSelectedNames(selected as number[], dishInstructionCategories).split(", ").map((name, i) => (
                          <div key={i} style={{ lineHeight: "1.8" }}>{name}</div>
                        ))}
                      </div>
                    )}
                    onChange={(e: any) => setSelectedInstructionCategories(getNormalizedIds(e.target.value))}
                    displayEmpty
                  >
                    {dishInstructionCategories.map((cat: any) => (
                      <MenuItem key={cat?.id} value={cat?.id}>
                        <Checkbox checked={selectedInstructionCategories.includes(cat?.id)} sx={{ "& .MuiSvgIcon-root": { color: colors.primary } }} />
                        {cat?.name}
                      </MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
              <FormFieldGroup>
                <FormLabel>Category Tags</FormLabel>
                <FormControl style={{ width: "100%" }}>
                  <DishSelect
                    multiple
                    value={selectedTagIds}
                    renderValue={(selected: any) => (
                      <div>
                        {getSelectedNames(selected as number[], categoryTags).split(", ").map((name, i) => (
                          <div key={i} style={{ lineHeight: "1.8" }}>{name}</div>
                        ))}
                      </div>
                    )}
                    onChange={(e: any) => setSelectedTagIds(getNormalizedIds(e.target.value))}
                    displayEmpty
                  >
                    {categoryTags.map((tag: any) => (
                      <MenuItem key={tag?.id} value={tag?.id}>
                        <Checkbox checked={selectedTagIds.includes(tag?.id)} sx={{ "& .MuiSvgIcon-root": { color: colors.primary } }} />
                        {tag?.name}
                      </MenuItem>
                    ))}
                  </DishSelect>
                </FormControl>
              </FormFieldGroup>
            </ThreeColGrid>

            {/* Row 6 — Checkboxes in a single row */}
            <div style={{ display: "flex", gap: "8px", marginTop: "20px", flexWrap: "wrap" }}>
              {[
                { label: "For Chefit", checked: forChefit, onChange: (e: any) => setForChefit(e.target.checked) },
                { label: "For Party", checked: forParty, onChange: (e: any) => setForParty(e.target.checked) },
                { label: "For Book by Dish", checked: forBookByDish, onChange: (e: any) => setForBookByDish(e.target.checked) },
                { label: "Popular", checked: isPopular, onChange: (e: any) => setIsPopular(e.target.checked) },
              ].map(({ label, checked, onChange }) => (
                <FormControlLabel
                  key={label}
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={onChange}
                      sx={{ "& .MuiSvgIcon-root": { color: colors.primary } }}
                    />
                  }
                  label={label}
                />
              ))}
            </div>

            {/* Row 7 — Description (full width) */}
            <FormFieldGroup style={{ marginTop: "20px" }}>
              <FormLabel>Description</FormLabel>
              <textarea
                placeholder="Description"
                value={description}
                rows={3}
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  fontSize: "14px",
                  borderRadius: "6px",
                  border: "1px solid rgba(108, 124, 147, 0.2)",
                  backgroundColor: "rgb(249, 250, 251)",
                  resize: "vertical",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                  outline: "none",
                }}
                onChange={(e: any) => setDescription(e.target.value)}
              />
            </FormFieldGroup>

            {/* Instruction text inputs for selected categories */}
            {selectedInstructionCategories.length > 0 && (
              <FormGrid style={{ marginTop: "20px" }}>
                {selectedInstructionCategories.map((catId: number) => (
                  <FormFieldGroup key={catId}>
                    <FormLabel>{getInstructionCategoryName(catId)}</FormLabel>
                    <DishTextField
                      fullWidth
                      variant="outlined"
                      placeholder={getInstructionCategoryName(catId)}
                      value={instructionInputs[catId] || ""}
                      error={showInstructionValidation && isInstructionTextMissing(catId)}
                      helperText={showInstructionValidation && isInstructionTextMissing(catId) ? "Dish instruction is required" : ""}
                      multiline
                      minRows={3}
                      onChange={(e: any) => setInstructionInputs({ ...instructionInputs, [catId]: e.target.value })}
                    />
                  </FormFieldGroup>
                ))}
              </FormGrid>
            )}

          </DialogContent>
          <DialogActions style={{ padding: "16px 24px", gap: "12px" }}>
            <OutlinedDelButton onClick={() => props.callBack()}>
              Cancel
            </OutlinedDelButton>
            <FilledButton onClick={handleSubmit} style={{ padding: "6px 32px" }}>
              Submit
            </FilledButton>
          </DialogActions>
        </Dialog>
    </div>
  )
}

export default UpdateDishDataDialog
